import request from './request';

// const mock = 'mock/139/api/saas';
const mock = '';


/**
 * @description: 通过商品Id查询商品详情
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435987
 * @return {*}
 */
export function getOrderById(id) {
    return request(`${mock}/mall/order-info/${id}`, {
        method: 'GET',
    });
}


/**
 * @description: 商店列表
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function getOrders(params) {
    return request(`${mock}/mall/order-info/page`, {
        method: 'POST',
        params,
    });
}


/**
 * @description: 配货完成
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function orderDistribution(params) {
    return request(`${mock}/mall/order/distribution`, {
        method: 'PUT',
        params,
    });
}


/**
 * @description: 确认发货
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/435978
 * @return {*}
 */
export function confirmDeliver(params) {
    return request(`${mock}/mall/order/send`, {
        method: 'PUT',
        params,
    });
}

/**
 * 获取订单操作记录
 */
export function getHistory(params) {
    return request(`${mock}/mall/operate/item`, {
        method: 'GET',
        params,
    });
}

/**
 * 获取列表统计数量
 */
export function getListCount(params) {
    return request(`${mock}/mall/order-info/total`, {
        method: 'GET',
        params,
    });
}

/**
 * 新增商城订单
 */
export function createOrder(params) {
    return request(`${mock}/mall/order-info`, {
        method: 'POST',
        params,
    });
}
